import Alpine from 'alpinejs'
import './nav';
import './contactForm';

/*
 *  Alpine.js
 */
window.Alpine = Alpine

Alpine.start()

function toggleOpen(){
    let el = document.getElementById("survey-box");
    el.classList.remove("form--hidden");
}
function toggleClose(){
    let formFields2 = Object.fromEntries(new FormData(document.querySelector('#survey')).entries());
    //console.log(formFields2)

    for (const field in formFields2) {
        if ( formFields2[field]){
            return 0;
        }
    }
    let el = document.getElementById("survey-box");
    el.classList.add("form--hidden");
}

/* Check all form elements for focus then reveal form */
if(document.body.contains(document.querySelector(".survey"))){
    let formFields = Object.fromEntries(new FormData(document.querySelector('.survey')).entries());
//console.log( formFields );

    for (const field in formFields) {
        let el = document.getElementById(field);
        el.addEventListener("focus", toggleOpen);
        el.addEventListener("focusout", toggleClose);
    }
}

/* Homepage popup */
document.addEventListener("DOMContentLoaded", function() {
    // Check if the visitor is on the homepage
    if (window.location.pathname === "/") {
        const now = new Date().getTime();
        const lastPopupTimestamp = localStorage.getItem("lastPopupTimestamp");
        const popupOverlay = document.getElementById("popupOverlay");
        const closeBtn = document.getElementById("closeBtn");

        if (!lastPopupTimestamp || now - lastPopupTimestamp >= 3600 * 1000) {
            const body = document.body;

            // Show the popup
            popupOverlay.style.display = "flex";

            // Close the popup when the close button is clicked
            closeBtn.addEventListener("click", function() {
                popupOverlay.style.display = "none";
                // Store the timestamp of the current popup display
                localStorage.setItem("lastPopupTimestamp", now);
            });

            // Close the popup when clicking outside the image
            popupOverlay.addEventListener("click", function(event) {
                if (event.target === popupOverlay) {
                    popupOverlay.style.display = "none";
                    // Store the timestamp of the current popup display
                    localStorage.setItem("lastPopupTimestamp", now);
                }
            });
        }
    }
});